var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var WTError = require('../../error');

var logger = require('../../config/logger');

var futureLink = require('../models/future-link');

var RemoteLink = require('../models/remote-link');

module.exports = function (_ref) {
  var request = _ref.request,
      routes = _ref.routes;

  /**
   * Add links to an existing board.
   * @param   {Object}  board Existing board object
   * @param   {Array}   links A list of links to be added to the board
   * @returns {Promise}       A board with created items
   */
  return (
    /*#__PURE__*/
    function () {
      var _addLinksToBoard = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(board, links) {
        var response, boardLinks;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                logger.info("Adding ".concat(links.length, " links to board with ID ").concat(board.id));
                _context.next = 4;
                return request.send(routes.boards.addLinks(board), links.map(futureLink));

              case 4:
                response = _context.sent;
                boardLinks = response.map(function (item) {
                  return new RemoteLink(item);
                });
                board.addLinks.apply(board, _toConsumableArray(boardLinks));
                return _context.abrupt("return", boardLinks);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                throw new WTError('There was an error when adding links to the board.', _context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function addLinksToBoard(_x, _x2) {
        return _addLinksToBoard.apply(this, arguments);
      }

      return addLinksToBoard;
    }()
  );
};